import { render, staticRenderFns } from "./editBale.vue?vue&type=template&id=70b0f09c&scoped=true"
import script from "./editBale.vue?vue&type=script&lang=js"
export * from "./editBale.vue?vue&type=script&lang=js"
import style0 from "./editBale.vue?vue&type=style&index=0&id=70b0f09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0f09c",
  null
  
)

export default component.exports